(() => {
  if (window.waMenuBridgeReady) return;
  window.waMenuBridgeReady = true;
  const desktop = matchMedia('(min-width: 1280px) and (hover: hover) and (pointer: fine)');
  const headers = new WeakMap();
  function setup(nav) {
    if (nav.dataset.waMenuBridgeReady || !nav.isHover || typeof nav.onMenuItemLeave !== 'function') return;
    nav.dataset.waMenuBridgeReady = 'true';
    const header = nav.closest('.site-header');
    const items = [...nav.querySelectorAll('.f-site-nav__item--mega')];
    const states = new Map();
    const nativeEnter = nav.onMenuItemEnter;
    const nativeLeave = nav.onMenuItemLeave;
    const nativeClose = nav.closeMegaDropdowns;
    const enabled = () => desktop.matches && !header.classList.contains('wa-header-compact');
    const cancel = item => {
      const state = states.get(item);
      if (state) { clearTimeout(state.timer); state.timer = null; }
    };
    const cancelAll = () => items.forEach(cancel);
    if (!headers.has(header)) headers.set(header, new Set());
    const siblings = headers.get(header);
    const controller = {nav, items, cancelAll};
    siblings.add(controller);
    const refreshBridge = item => {
      const state = states.get(item);
      if (!state) return;
      state.bridge.hidden = true;
      if (!enabled()) return;
      const trigger = item.getBoundingClientRect();
      const panel = state.panel.getBoundingClientRect();
      const gap = panel.top - trigger.bottom;
      if (gap <= 0 || panel.width <= 0 || trigger.width <= 0) return;
      const parent = state.panel.offsetParent || header;
      const origin = parent.getBoundingClientRect();
      const left = Math.max(0, trigger.left - 8);
      const right = Math.min(window.innerWidth, trigger.right + 8);
      state.bridge.style.left = `${left - origin.left - parent.clientLeft + parent.scrollLeft}px`;
      state.bridge.style.top = `${trigger.bottom - 1 - origin.top - parent.clientTop + parent.scrollTop}px`;
      state.bridge.style.width = `${right - left}px`;
      state.bridge.style.height = `${gap + 2}px`;
      state.bridge.hidden = false;
    };
    const scheduleLeave = (item, event, index) => {
      cancel(item);
      clearTimeout(nav.timeoutEnter);
      if (item.contains(document.activeElement)) return;
      const state = states.get(item);
      state.timer = setTimeout(() => {
        state.timer = null;
        if (!nav.isConnected || !item.isConnected || item.matches(':hover') || item.contains(document.activeElement)) return;
        nativeLeave.call(nav, event, index);
      }, 240);
    };
    items.forEach(item => {
      const panel = item.querySelector('.f-site-nav__dropdown--level2');
      if (!panel) return;
      const bridge = document.createElement('span');
      bridge.className = 'wa-menu-bridge';
      bridge.setAttribute('aria-hidden', 'true');
      bridge.hidden = true;
      item.append(bridge);
      states.set(item, {panel, bridge, timer: null});
      item.addEventListener('focusin', () => { cancelAll(); refreshBridge(item); });
      item.addEventListener('focusout', event => {
        if (!enabled() || item.contains(event.relatedTarget) || item.matches(':hover')) return;
        scheduleLeave(item, {target: item});
      });
    });
    nav.onMenuItemEnter = function(event, index) {
      cancelAll();
      if (enabled()) siblings.forEach(other => {
        other.cancelAll();
        if (other.nav !== nav) {
          clearTimeout(other.nav.timeoutEnter);
          clearTimeout(other.nav.timeoutLeave);
          other.items.forEach(item => item.classList.remove('f-menu__item-active'));
        }
      });
      const result = nativeEnter.call(this, event, index);
      if (enabled()) {
        refreshBridge(event.target);
        requestAnimationFrame(() => { if (event.target.isConnected) refreshBridge(event.target); });
      }
      return result;
    };
    nav.onMenuItemLeave = function(event, index) {
      if (!enabled() || !states.has(event.target)) return nativeLeave.call(this, event, index);
      if (event.target.contains(event.relatedTarget)) { cancel(event.target); return; }
      scheduleLeave(event.target, event, index);
    };
    nav.closeMegaDropdowns = function(...args) {
      cancelAll();
      return nativeClose.apply(this, args);
    };
    const refresh = () => {
      if (!nav.isConnected) {
        cancelAll();
        window.removeEventListener('resize', refresh);
        desktop.removeEventListener('change', refresh);
        siblings.delete(controller);
        return;
      }
      if (!enabled()) {
        cancelAll();
        states.forEach(state => { state.bridge.hidden = true; });
        if (items.some(item => item.classList.contains('f-menu__item-active'))) nav.closeMegaDropdowns();
        return;
      }
      items.forEach(refreshBridge);
    };
    window.addEventListener('resize', refresh, {passive: true});
    desktop.addEventListener('change', refresh);
  }
  const scan = root => customElements.whenDefined('site-nav').then(() => {
    if (root.matches?.('site-nav')) setup(root);
    root.querySelectorAll('site-nav').forEach(setup);
  });
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
